import { DnvMapState, SearchTypeInfo } from 'dnv-lib';
import { LoggerOptions } from './logger';

export class AppConfig {
  initialDnvMapState: DnvMapState;
  webApiEndpoint: string;
  defaultPath: string;
  loggingOption: LoggerOptions;
  dnvSearchApiEndpoint: string;
  initialSearchIcons: SearchTypeInfo[];
}
